<template>
    <div>
        <NavBar />
        <div class="container mx-auto">
            <header>
                <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                    <h1 class="text-3xl font-bold leading-tight text-gray-900">
                        Review and Send
                    </h1>
                </div>
            </header>
        </div>

        <main class="container mx-auto">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="px-4 py-6 sm:px-0 bg-white rounded shadow-sm">
                    <!-- START CONTENT -->
                    <div class="flex flex-wrap px-4">
                            <div class="w-full md:w-1/3 my-4">
                                <h6 class="font-bold"> Message Type </h6>
                                <p v-if="messageType == 'sms'"> {{ messageTypeFormatted }} </p>
                                <p v-else> Audio </p>
                            </div>

                            <div class="w-full md:w-1/3 my-4">
                                <h6 class="font-bold"> Contact List Type </h6>
                                <p> {{ contactListType }} </p>
                            </div>

                            <template v-if="messageType == 'audio'">
                                <div class="w-full md:w-1/3 my-4">
                                    <h6 class="font-bold"> Audio Recording Type </h6>
                                    <p> {{ messageTypeFormatted }} </p>
                                </div>

                                <div class="w-full md:w-1/3 my-4">
                                    <h6 class="font-bold"> Message Recording Type </h6>
                                    <p> {{ messageRecordingTypeData }} </p>
                                </div>

                                <div class="w-full md:w-1/3 my-4">
                                    <h6 class="font-bold"> Uploaded Audio File </h6>
                                    <p> {{ fileName }} </p>
                                </div>
                            </template>


                            <div class="w-full md:w-1/3 my-4">
                                <h6 class="font-bold">Contact List</h6>
                                <p> {{ contactListDescription }} </p>
                            </div>

                            <div class="w-full md:w-1/3 my-4">
                                <h6 class="font-bold"> Caller ID </h6>
                                <p> {{ callerInfo }} </p>
                            </div>

                            <div class="w-full md:w-1/3 my-4">
                                <h6 class="font-bold"> Speed of Messages </h6>
                                <p> {{ frequency }} </p>
                            </div>

                            <div class="w-full md:w-1/3 my-4">
                                <h6 class="font-bold"> Schedule Campaign </h6>
                                <p> TEST </p>
                            </div>
                        </div>

                        <div class="w-full px-4">
                                <button
                                    class="bg-green-500 hover:bg-green-700 text-white font-bold py-3 px-4 shadow rounded"
                                    @click="send"
                                >
                                    Send Campaign
                                </button>
                        </div>
                    <!-- END CONTENT -->
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import NavBar from "../components/NavBar";

export default {
    name: "ReviewAndSend",
    components: {
        NavBar,
    },
    data() {
        return {
            "messageRecordingTypeData": "",
            "audioFileUrl": "",
            "fileName": "",
            "caller": {}
        }
    },
    methods: {
        send() {
            this.$store.dispatch("sanitizeAndSend")
                .then(response => {
                    if (response.status === 200) {
                        this.$store.commit("reset");
                        this.$router.push("/congratulations");
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        }
    },
    computed: {
        contactListDescription() {
            const { description } = this.contactList(this.selectedList);

            return description;
        },
        callerInfo() {
            return `${this.caller.name} - ${this.caller.phone_number}`;
        },
        ...mapGetters([
            "messageType",
            "messageTypeFormatted",
            "contactListType",
            "contactList",
            "message",
            "recording",
            "frequency",
            "selectedList",
            "selectedCaller",
            "findCallerById",
            "findRecordingById",
            "callerName",
            "callerPhoneNumber",
        ]),
    },
    mounted() {
        this.$watch("audioFileUrl", function () {
            console.log("source changed");
            this.$refs.player.load();
        });

        // TODO: Dispatch api request on every mount?
        if(this.messageType === "audio") {

            this.$store.dispatch("loadRecordings")
                .then(() => {
                    const recording = this.findRecordingById(this.recording);
                    if (recording !== undefined) {
                        this.messageRecordingTypeData = recording.type;
                        this.fileName = recording.file_name;
                    }
                });
        }

        console.log(this.caller);
        this.caller = this.findCallerById(this.selectedCaller);
    }
}
</script>